import { AfterViewInit, Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { AppService } from "src/_services/app.service";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { MatSort, MatTableDataSource } from "@angular/material";

@Component({
  selector: "app-catalogue-markets",
  templateUrl: "./catalogue-markets.component.html",
  styleUrls: ["./catalogue-markets.component.scss"],
})
export class CatalogueMarketsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  providerId;
  eventId = "";
  eventName = "";
  sportId;
  searchKey = "";
  sportName: string = "";
  openDate = 0;
  filteredMarkets = new MatTableDataSource<any>();

  openMarketsTableColumns = [
    "Event Id",
    "Market Id",
    "Market Name",
    "Category",
    "Market Status",
    "UpdatedName",
    "Actions",
  ];

  categories = ["MATCH", "INNINGS", "OVER", "PLAYER", "HEAD-TO-HEAD", "OTHER"];
  private pollingInterval: any;

  constructor(
    private appService: AppService,
    private router: Router,
    private activetedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.activetedRoute.queryParams.subscribe((params) => {
      this.providerId = params["providerId"];
      this.sportId = params["sportId"];
      this.eventId = params["eventId"];
      this.eventName = params["eventName"];
      this.sportName = params["sportName"];
      this.openDate = parseInt(params["openDate"]);
    });

    this.getMarkets();

    // Set up polling every 5 seconds
    // this.pollingInterval = setInterval(() => {
    //   this.getMarkets();
    // }, 5000);
  }

  ngAfterViewInit() {
    this.filteredMarkets.sort = this.sort;
    this.filteredMarkets.sortingDataAccessor = (item, property) => {
      switch (property) {
        case "Market Id":
          return item.marketId;
        case "Market Name":
          return item.marketName;
        case "Market Status":
          return item.status;
        case "Category":
          return item.category;
        default:
          return item[property];
      }
    };
  }

  getMarkets() {
    try {
      let filters = {
        providerId: this.providerId,
        sportId: this.sportId,
        eventId: this.eventId,
      };
      this.appService.getPremiumMarkets(filters).subscribe((response) => {
        if (response.status === "RS_OK") {
          const sortedMarkets = response.markets.sort((a, b) => {
            const nameA = (a.marketName || "").toLowerCase();
            const nameB = (b.marketName || "").toLowerCase();
            return nameA.localeCompare(nameB);
          });
          this.filteredMarkets.data = sortedMarkets;
        } else {
          this.appService.openErrorBar(response.errorDescription);
        }
      });
    } catch (err) {
      console.log(err);
    }
  }

  searchHandlerChange() {
    this.filteredMarkets.filter = this.searchKey;
  }

  refreshMarkets() {
    this.getMarkets();
  }

  saveChanges(value) {
    let index = this.filteredMarkets.data.findIndex(
      (market) => market.marketId === value
    );
    let element = this.filteredMarkets.data[index];
    try {
      let filters = {
        providerId: this.providerId,
        sportId: this.sportId,
        eventId: this.eventId,
        marketId: element.marketId,
        oldMarketName: element.marketName,
        marketName: element.updatedName,
        category: element.category,
        status: element.status,
      };
      this.appService.updatePremiumMarketStatus(filters).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } catch (err) { }
  }

  onSelectingCategory(value, element) {
    let index = this.filteredMarkets.data.findIndex(
      (market) => market.marketId === element
    );
    this.filteredMarkets.data[index] = {
      ...this.filteredMarkets.data[index],
      isDisabled: true,
      category: value,
    };
  }

  onNameChange(name, element) {
    let index = this.filteredMarkets.data.findIndex(
      (market) => market.marketId === element
    );
    if (name === "") {
      this.filteredMarkets.data[index] = {
        ...this.filteredMarkets.data[index],
        isDisabled: false,
      };
      return;
    }
    this.filteredMarkets.data[index] = {
      ...this.filteredMarkets.data[index],
      isDisabled: true,
      updatedName: name,
    };
  }

  onSelectingStatus(value, element) {
    let index = this.filteredMarkets.data.findIndex(
      (market) => market.marketId === element
    );
    this.filteredMarkets.data[index] = {
      ...this.filteredMarkets.data[index],
      isDisabled: true,
      status: value.checked === false ? "BLOCKED" : "ACTIVE",
    };
  }

  disabled(value) {
    let index = this.filteredMarkets.data.findIndex(
      (market) => market.marketId === value
    );
    return this.filteredMarkets.data[index]
      ? this.filteredMarkets.data[index].isDisabled
      : false;
  }

  goBack() {
    this.router.navigate(["catalog/catalog-events"], {
      queryParams: {
        providerId: this.providerId,
        sportId: this.sportId,
        sportName: this.sportName,
      },
    });
  }

  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  ngOnDestroy() {
    // Clear the polling interval when component is destroyed
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  }
}
